import { render, staticRenderFns } from "./CurrentSection.vue?vue&type=template&id=2e423d32&scoped=true&"
import script from "./CurrentSection.vue?vue&type=script&lang=js&"
export * from "./CurrentSection.vue?vue&type=script&lang=js&"
import style0 from "./CurrentSection.vue?vue&type=style&index=0&id=2e423d32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e423d32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
